/*** IMPORTS FROM imports-loader ***/
(function() {

define([
    'jquery',
    'mustache',
    'javascript-debounce',
    'pip-model',
    'pip-cart',
    'pip-events',
    'pip-trackif',
    'pip-common.aisle-bay',
    'pip-common.text-aisle-bay',
    'pip-need-more-bopis-products',
    'pip-paypal',
    'pip-express_delivery',
    'pip-common.dynamic_eta',
    'pip-common.utils',
    'pip-analytics__messaging',
    'pip-common.expandable',
    'thd-cart-bindings',
    'window',
    'pip-domain',
    'pip-sub_buybelt',
    'pip-instant_checkout',
    'pip-buybelt-redesign-react'
  ],
  function (
    $,
    Mustache,
    debounce,
    pip,
    pipCart,
    pipEvents,
    pipTrackif,
    pipAisleBay,
    pipTextAisleBay,
    pipNeedMoreBopisProducts,
    pipPaypal,
    pipExpressDelivery,
    pipDynamicEta,
    pipCommonUtils,
    pipAnalyticsMessaging,
    pipCommonExpandable,
    thdCartBindings,
    window,
    pipDomain,
    pipSubBuyBelt,
    pipInstantCheckout,
    pipBuyBeltReact
  ) {

    var LIVEGOODS_DEPARTMENT = '28';
    var LIVEGOODS_CLASS = '8';

    var model = {
      isItemExtensionShared: function modelIsItemExtensionShared() {
        var productsData = pip.products && pip.products.primary && pip.products.primary.data;

        return (productsData && productsData.itemExtension && productsData.itemExtension.sharedItem);
      },
      getBossSharedSkuEnhancementFeatureEnabled: function buybeltGetBossSharedSkuEnhancementFeatureEnabled() {
        var isB2BExperience = pip.isB2BCustomer;
        var isItemShared = model.isItemExtensionShared();

        var secondaryBuyOnlineShipToStore = pip.fulfillment && pip.fulfillment.store && pip.fulfillment.store.secondaryBuyOnlineShipToStore;
        var bossSharedSkuEnhancementFeature = pip.features.bossSharedSkuEnhancement && secondaryBuyOnlineShipToStore && isItemShared;
        var bossSharedSkuEnhancementFeatureB2B = pip.features.bossSharedSkuEnhancementB2B && secondaryBuyOnlineShipToStore && isItemShared;

        return (bossSharedSkuEnhancementFeature && !isB2BExperience) || (bossSharedSkuEnhancementFeatureB2B && isB2BExperience);
      },
      doesBossExclusionAppliesInLocalStore: function doesBossExclusionApplies() {
        if (pip && pip.shippingExclusion &&
          pip.shippingExclusion.bossExclusionLocations &&
          pip.customer && pip.customer.localStore !== null) {
          var localizedStoreState = pip.customer.localStore.statecode;
          var isLocalStoreAK = pip.shippingExclusion.bossExclusionLocations.indexOf("AK") !== -1 && localizedStoreState === "AK";
          var isLocalStoreHI = pip.shippingExclusion.bossExclusionLocations.indexOf("HI") !== -1 && localizedStoreState === "HI"
          return (isLocalStoreAK || isLocalStoreHI)
        }
      }
    };

    var view = {
      selectors: {
        paypalShipToHome: '.paypal_ship_to_home #paypal_checkout_btn',
        paypalPickUpInStore: '.paypal_pick_up_in_store #paypal_checkout_btn',
        paypalBuyOnlineDeliverFromStore: '.paypal_buy_online_deliver_from_store #paypal_checkout_btn',
        paypalShipToStore: '.paypal_ship_to_store #paypal_checkout_btn',
        paypalCheckoutBtn: '#paypal_checkout_btn',
        deliveryPriceMessageSelector: '.bodfs-delivery-price-message',
        subBuybelt: '#buybelt__sub_buybelt',
        uppersubBuybelt: '#buybelt__sub_buybelt',
        storeWrapper: '#buybelt .buybelt__store-wrapper',
        onlineWrapper: '#buybelt .buybelt__online-wrapper',
        buybeltWrapper: '#buybelt-wrapper',
        atcButtonText: '#atc_shipIt span',
        shippingOptionsLink: '#shipping_options_tooltip_link_container',
        subscriptionOptionsMessage: '#subscription_options_message',
        shippingOptionsTooltipSubscribedClassName: 'shipping_options_tooltip_link_container_bodfs_as_service_level-subscribe',
        shippingOptionsTooltipUnsubscribedClassName: 'shipping_options_tooltip_link_container_bodfs_as_service_level',
        subscriptionOptionsMessageClassName: 'subscription_options_message',
        subscriptionOptionsMessageHiddenClassName: 'subscription_options_message-hidden',
        freeDeliveryMessageSubscribedClassName: 'heading-message--subscribed',
        freeDeliveryMessageWrapper: '.shipping-box > .heading-message',
        deliveryPrice: '.bodfs-delivery-price',
        expressDelivery: '.express-delivery-bodfs',
        freeDeliveryMessage: '.buybelt__box.shipping-box .heading-message span',
        myStore: '#myStore',
        nonbuyableSqFtNumberIdName: 'non-buyable-service__square-footage-number',
        nonbuyableServiceEstimate: 'non-buyable-service__estimated-number',
        showPickUpLink: '#buybelt-show-pick-up-link',
        dualPathOptions: '#buybelt_dual-path-show-pick-up-options, #buybelt_dual-path-show-shipping-options',
        addToCartButton: '#buybelt > div:first-child .atc-button',
        addToCartButtonErrorStateClassName: 'atc-button--errorState',
        fulfillmentTitleFallback: '.buybelt__fulfillment-title_fallback',
        storeMessageHeading: '.store-message__heading-message',
        fulfillmentTitleErrorState: 'buybelt__fulfillment-title--errorState',
        storeMessageOptions: '.store-message__boss-bopis-options',
        storeMessageCutoffOptions: '.store-message__boss-bopis-options-cutoff',
        storeMessageHeadingErrorState: 'store-message__heading-message--errorState',
        storeMessageOptionsErrorState: 'store-message__boss-bopis-options--errorState',
        storeMessageCutoffOptionsErrorState: 'store-message__boss-bopis-options-cutoff--errorState',
        needMoreQuantityTooltip: '#need-more-quantity-tooltip-trigger',
        aisleBayContainer: '#aisle-bay-container',
        aisleBayOptionsDisplayClassName: 'store-message__boss-bopis-options_aisle-and-bay-display',
        buybeltErrorState: '#buybelt__error-state',
        toolTipCloseButton: '.ToolTip__closebutton',
        shippingAddToCartButton: '#shipping__atcButton'
      },
      templates: {
        raw: {
          shipping__default: $('#buybelt__shipping').html(),
          shipping__default__bodfs_as_service_level: $('#buybelt__shipping-bodfs_as_service_level').html(),
          shipping__options_link_bodfs_as_service_level: $('#buybelt__shipping-options_link_bodfs_as_service_level').html(),
          shipping__threshold: $('#buybelt__shipping-threshold').html(),
          shipping__out_of_stock_online_only: $('#buybelt__shipping-out_of_stock_online_only').html(),
          shipping__backordered_online: $('#buybelt__shipping-backordered_online').html(),
          shipping__backordered_online__bodfs_as_service_level: $('#buybelt__shipping-backordered_online-bodfs_as_service_level').html(),
          shipping__unavailable: $('#buybelt__shipping-unavailable').html(),
          shipping__express_delivery: $('#buybelt__express-delivery').html(),
          shipping__express_delivery__bodfs_as_service_level: $('#buybelt__express-delivery-bodfs_as_service_level').html(),
          shipping__dual_path_opted_in: $('#buybelt__shipping_dual-path-opted-in').html(),
          shipping__online_inventory_warning: $('#buybelt__online_inventory_warning').html(),
          store__dual_path_opted_in: $('#buybelt__store_dual-path-opted-in').html(),
          store__default: $('#buybelt__store').html(),
          store__default_bopis_cutoff: $('#buybelt__store_bopis_cutoff').html(),
          store__bopis_to_boss_fallback: $('#buybelt__store-bopis-to-boss-fallback').html(),
          store__bopis_to_boss_fallback_bopis_cutoff: $('#buybelt__store-bopis-to-boss-fallback_bopis_cutoff').html(),
          store__alpha_prompt: $('#buybelt__store-alpha_prompt').html(),
          store__attach_labor_opted_in: $('#buybelt__attach-labor-opted-in').html(),
          store__not_sold_in_stores: $('#buybelt__store-not_sold_in_stores').html(),
          store__store_only: $('#buybelt__store_only').html(),
          store__store_only_seasonal: $('#buybelt__store_only_seasonal').html(),
          store__store_only_in_stock: $('#buybelt__store_only_in_stock').html(),
          store__store_only_out_of_stock: $('#buybelt__store_only_out_of_stock').html(),
          store__boss_store_only: $('#buybelt__boss_store_only').html(),
          store__limited_stock: $('#buybelt__store-limited_stock').html(),
          store__out_of_stock: $('#buybelt__store-out_of_stock').html(),
          store__boss_backordered: $('#buybelt__store-boss-backordered').html(),
          store_inventory_warning: $('#buybelt__inventory_warning').html(),
          store__not_localized: $('#buybelt__store-not-localized').html(),
          store__subscriptions: $('#buybelt__store-subscriptions').html(),
          nearby_store__in_stock: $('#buybelt__nearby_store-in_stock').html(),
          nearby_store__in_stock_bopis_cutoff: $('#buybelt__nearby_store-in_stock_bopis_cutoff').html(),
          nearby_store__limited_stock: $('#buybelt__nearby_store-limited_stock').html(),
          store__boss_restriction_to_state: $('#buybelt__store-boss_restriction_to_state').html(),

          merchandise: $('#buybelt__merchandise').html(),
          install_services_appointment: $('#buybelt__install_services-appointment').html(),
          install_services_measure: $('#buybelt__install_services-measure').html(),
          install_services_measure_with_calculator: $('#buybelt__install_services-measure-with-calculator').html(),
          install_services_measure_without_calculator: $('#buybelt__install_services-measure-without-calculator').html(),
          messaging__backordered: $('#buybelt__messaging__backordered').html(),
          messaging__discontinued: $('#buybelt__messaging__discontinued').html(),
          //region SubBuybelt
          sub_buybelt: $('#sub_buybelt').html(),
          sub_buybelt__seperate_boss_exclusion:  $('#sub_buybelt__seperate_boss_exclusion').html(),
          sub_buybelt__your_localstore_info: $('#sub_buybelt__your_localstore_info').html(),
          sub_buybelt__cannot_be_shipped: $('#sub_buybelt__cannot_be_shipped').html(),
          sub_buybelt__express_delivery: $('#sub_buybelt__express_delivery').html(),
          sub_buybelt__paypal: $('#sub_buybelt__paypal').html(),
          sub_buybelt__returns: $('#sub_buybelt__returns').html(),
          buybelt_delivery_tooltip__template: $('#buybelt_delivery_tooltip').html()
          //endregion
        },
        getMessagingTemplate: function () {
          if (pip.inventory.isSharedBackordered) {
            return view.templates.raw.messaging__backordered;
          }
          return '';
        },
        getStoreTemplate: function () {
          if (pip.customer.dualPath && pip.customer.dualPath.isOptedIn) {
            return view.templates.raw.store__dual_path_opted_in;
          }

          if (pip.customer.attachLabor && pip.customer.attachLabor.isOptedIn && pip.customer.attachLabor.itemId === pip.products.primary.data.itemId) {
            return view.templates.raw.store__attach_labor_opted_in;
          }

          if (!pip.customer.isLocalized) {
            return view.templates.raw.store__not_localized;
          }

          if (pip.features.multistoreFeatureEnabled && !pip.isAnchorStore && pip.inventory.nearbyStore) {
            pip.viewModel.buybelt.availabilityStatus.store = {};
            if (pip.inventory.nearbyStore.isInStock) {
              pip.viewModel.buybelt.availabilityStatus.store.bopis = 'available';
              if (pip.features.isBopisCutoffEnabled && pipCommonUtils.isAfterBopisCutoff()) {
                return view.templates.raw.nearby_store__in_stock_bopis_cutoff;
              }
              return view.templates.raw.nearby_store__in_stock;
            } else if (pip.inventory.nearbyStore.isLimitedQuantity) {
              if (!pip.features.nearbyLimitedStockBOSSEnabled || (pip.features.nearbyLimitedStockBOSSEnabled && !pipCommonUtils.deepGet(pip, 'fulfillment.store.buyOnlineShipToStore'))) {
                  pip.viewModel.buybelt.availabilityStatus.store.bopis = 'limited quantity';
                  return view.templates.raw.nearby_store__limited_stock;
              }
            }
          }

          if (pip.fulfillment.store) {
            pip.viewModel.buybelt.availabilityStatus.store = {};

            if (pip.customer.subscriptions && pip.customer.subscriptions.isOptedIn) {
              return view.templates.raw.store__subscriptions;
            }

            if (pip.viewModel.bossSharedSkuEnhancementFeature) {
              if (pip.features.isBopisCutoffEnabled && pipCommonUtils.isAfterBopisCutoff()) {
                return view.templates.raw.store__bopis_to_boss_fallback_bopis_cutoff;
              }
              return view.templates.raw.store__bopis_to_boss_fallback;
            }

            if (pip.fulfillment.store.buyOnlineShipToStore && !pip.viewModel.doesBossExclusionAppliesInLocalStore) {
              pip.viewModel.buybelt.availabilityStatus.store.boss = 'available';

              if (pip.products.primary.data.itemExtension.sharedItem) {
                pip.viewModel.buybelt.availabilityStatus.store.bopis = 'oos';
              }

              if (pip.inventory.isSharedBackordered) {
                if (pip.features.isBopisCutoffEnabled && pipCommonUtils.isAfterBopisCutoff()) {
                  return view.templates.raw.store__default_bopis_cutoff;
                }
                return view.templates.raw.store__default;
              }
              if (pip.inventory.online.isBackordered) {
                return view.templates.raw.store__boss_backordered;
              }
              if (pip.products.primary.data.itemExtension.sharedItem && pip.fulfillment.store.buyOnlineShipToStore.isInventoryRestricted) {
                pip.viewModel.buybelt.availabilityStatus.store.boss = 'oos';
                return view.templates.raw.store__out_of_stock;
              }
              if (pip.features.storeMessagingEnabled &&
                pip.fulfillment.isPurchasableInLocalStoreBoss || pip.fulfillment.isZeroStockInLocalStoreBoss) {
                return view.templates.raw.store__boss_store_only;
              }
              if (!pip.fulfillment.store.buyOnlineShipToStore.isInventoryRestricted) {
                if (pip.features.isBopisCutoffEnabled && pipCommonUtils.isAfterBopisCutoff()) {
                  return view.templates.raw.store__default_bopis_cutoff;
                }
                return view.templates.raw.store__default;
              }
            } else if (pip.fulfillment.store.buyOnlineShipToStore && pip.viewModel.doesBossExclusionAppliesInLocalStore) {
              return view.templates.raw.store__boss_restriction_to_state;
            }

            if (pip.fulfillment.store.buyOnlinePickUpInStore) {
              pip.viewModel.buybelt.availabilityStatus.store.bopis = 'available';

              if (pip.fulfillment.store.buyOnlinePickUpInStore.isInventoryRestricted) {
                if (pip.inventory.store.isLimitedQuantity) {
                  pip.errorState = pipAnalyticsMessaging.errorStates.fulfillment.store.isLimitedQuantity;
                  pip.viewModel.buybelt.availabilityStatus.store.bopis = 'limited quantity';
                  return view.templates.raw.store__limited_stock;
                }
                if (!pip.inventory.store.isInStock) {
                  pip.errorState = pipAnalyticsMessaging.errorStates.fulfillment.store.isOutOfStock;
                  pip.viewModel.buybelt.availabilityStatus.store.bopis = 'oos';
                  return view.templates.raw.store__out_of_stock;
                }
              }
              if (pip.fulfillment.store.buyOnlinePickUpInStore.isStoreAssortmentRestricted) {
                pip.viewModel.buybelt.availabilityStatus.store.bopis = 'oos';
                return view.templates.raw.store__out_of_stock;
              }
              if (pip.fulfillment.store.buyOnlinePickUpInStore.isAlphaPromptRestricted) {
                pip.errorState = pipAnalyticsMessaging.errorStates.fulfillment.store.isAlphaPromptRestricted;
                pip.viewModel.buybelt.availabilityStatus.store.bopis = 'alpha prompt';
                return view.templates.raw.store__alpha_prompt;
              }
              if (pip.features.isBopisCutoffEnabled && pipCommonUtils.isAfterBopisCutoff()) {
                return view.templates.raw.store__default_bopis_cutoff;
              }
              return view.templates.raw.store__default;
            }
          }

          if (pip.features.storeMessagingEnabled) {
            if (pip.fulfillment.isPurchasableInLocalStoreInStock) {
              return view.templates.raw.store__store_only_in_stock;
            }

            if (pip.fulfillment.isZeroStockInLocalStoreActive && !pip.features.liveGoodsMessagingEnabled) {
              return view.templates.raw.store__store_only_out_of_stock;
            }

            if (pip.fulfillment.isZeroStockInLocalStoreActive && pip.features.liveGoodsMessagingEnabled) {
              var isLiveGoodDepartment = pip.products.primary.data.info.productDepartment === LIVEGOODS_DEPARTMENT;
              var isLiveGoodClass = pip.products.primary.data.info.classNumber === LIVEGOODS_CLASS;
              var isLiveGoodSeason = pip.products.primary.data.info.seasonStatusEligible;
              if (isLiveGoodDepartment && isLiveGoodClass && typeof isLiveGoodSeason !== 'undefined') {
                return view.templates.raw.store__store_only_seasonal;
              } else if (isLiveGoodDepartment && isLiveGoodClass && typeof isLiveGoodSeason == 'undefined') {
                return view.templates.raw.store__store_only_out_of_stock;
              } else {
                return view.templates.raw.store__store_only_out_of_stock;
              }
            }

            if (pip.fulfillment.isPurchasableInLocalStoreBoss || pip.fulfillment.isZeroStockInLocalStoreBoss) {
              return view.templates.raw.store__boss_store_only;
            }
          }

          if (pip.fulfillment.isPurchasableInLocalStore) {
            return view.templates.raw.store__store_only;
          }

          if (pip.fulfillment.isAssortedToLocalStore && !pip.fulfillment.isPurchasableInLocalStore) {
            return view.templates.raw.store__out_of_stock;
          }

          return view.templates.raw.store__not_sold_in_stores;
        },
        getShippingTemplate: function () {
          if (pip.fulfillment.shipping) {
            pip.viewModel.buybelt.availabilityStatus.shipping = {};

            if (pip.customer && pip.customer.dualPath && pip.customer.dualPath.isOptedIn) {
              return view.templates.raw.shipping__dual_path_opted_in;
            }

            // TODO: Once there is a single treatment for sth and/or bodfs, then code in this if/else if/else
            // block should collapse.
            if (pip.features.bodfsAsServiceLevelFeature
              && pip.fulfillment.shipping.shipToHome
              && pip.fulfillment.shipping.buyOnlineDeliverFromStore
              && !pip.fulfillment.shipping.buyOnlineDeliverFromStore.isAlphaPromptRestricted
              // We can't offer sth + bodfs mixed shipping panel unless we have storeDeliveryTimeline.
              // If we don't have storeDeliveryTimeline, it most likely means that there were no
              // deliver-from-store options that were cost-competitive with sth options.
              && pip.fulfillment.shipping.buyOnlineDeliverFromStore.storeDeliveryTimeline) {

              pip.viewModel.buybelt.availabilityStatus.shipping.bodfs = 'displayed';
              pip.viewModel.buybelt.availabilityStatus.shipping.sth = 'available';

              if (pip.inventory.isSharedBackordered) {
                return view.templates.raw.shipping__default__bodfs_as_service_level;
              }
              if (pip.inventory.online.isBackordered) {
                return view.templates.raw.shipping__backordered_online__bodfs_as_service_level;
              }
              if (pip.inventory.online.isOutOfStock) {
                pip.viewModel.buybelt.availabilityStatus.shipping.sth = 'oos';
                return view.templates.raw.shipping__express_delivery__bodfs_as_service_level;
              }
              return view.templates.raw.shipping__default__bodfs_as_service_level;
            } else if (pip.features.bodfsAsServiceLevelFeature
              && pip.fulfillment.shipping.shipToHome
              && pip.fulfillment.shipping.buyOnlineDeliverFromStore
              && !pip.fulfillment.shipping.buyOnlineDeliverFromStore.isAlphaPromptRestricted
              && pip.inventory.online.isOutOfStock) {
              // This was broken out on its own to avoid another level of nesting in the previous block.  It's ugly either way.
              pip.viewModel.buybelt.availabilityStatus.shipping.bodfs = 'displayed';
              pip.viewModel.buybelt.availabilityStatus.shipping.sth = 'oos';
              return view.templates.raw.shipping__express_delivery__bodfs_as_service_level;
            } else if (pip.fulfillment.shipping.shipToHome) {
              pip.viewModel.buybelt.availabilityStatus.shipping.sth = 'available';

              if (pip.inventory.isSharedBackordered) {
                return view.templates.raw.shipping__default;
              }
              if (pip.inventory.online.isBackordered) {
                return view.templates.raw.shipping__backordered_online;
              }
              if (pip.inventory.online.isOutOfStock) {
                pip.viewModel.buybelt.availabilityStatus.shipping.sth = 'oos';
                return view.templates.raw.shipping__out_of_stock_online_only;
              }
              return view.templates.raw.shipping__default;
            } else if (pip.fulfillment.shipping.buyOnlineDeliverFromStore
              && !pip.fulfillment.shipping.buyOnlineDeliverFromStore.isAlphaPromptRestricted) {

              pip.viewModel.buybelt.availabilityStatus.shipping.bodfs = 'displayed';

              var isSharedType = pip.products.primary.data && pip.products.primary.data.availabilityType === 'Shared';

              if (isSharedType) {
                pip.viewModel.buybelt.availabilityStatus.shipping.sth = 'oos';
              }

              if (pip.features.bodfsAsServiceLevelFeature) {
                return view.templates.raw.shipping__express_delivery__bodfs_as_service_level;
              } else {
                return view.templates.raw.shipping__express_delivery;
              }
            }
          }

          if (pip.inventory.online.isOutOfStock && pip.products.primary.data.itemExtension.onlineOnlyItem) {
            pip.viewModel.buybelt.availabilityStatus.shipping = {
              sth: 'oos'
            };
            return view.templates.raw.shipping__out_of_stock_online_only;
          } else {
            return view.templates.raw.shipping__unavailable;
          }
        },
        getInstallServicesTemplate: function () {
          if (pip.installServices.scheduleAnAppointment) {
            return view.templates.raw.install_services_appointment;
          }
          if (pip.installServices.scheduleAMeasure) {
            return view.templates.getScheduleMeasureTemplate();
          }
        },
        getScheduleMeasureTemplate: function () {
          var unitSpecialPrice = true;
          if (pip.products.primary.data
            && pip.products.primary.data.storeSkus
            && pip.products.primary.data.storeSkus[0]
            && pip.products.primary.data.storeSkus[0].pricing
            && pip.products.primary.data.storeSkus[0].pricing.unitSpecialPrice === undefined) {
            unitSpecialPrice = false;
          }
          if (
            pip.projectCalculatorEligible
            && pip.features.projectCalculatorFeature.isFeatureEnabled
            && pip.products.primary.data
            && pip.products.primary.data.storeSkus
            && pip.products.primary.data.storeSkus[0]
            && pip.products.primary.data.storeSkus[0].pricing
            && pip.products.primary.data.storeSkus[0].pricing.alternatePricingDisplay
            && unitSpecialPrice
          ) {
            return Mustache.render(
              view.templates.raw.install_services_measure_with_calculator,
              viewModel.getScheduleMeasureData()
            );
          }
          return Mustache.render(
            view.templates.raw.install_services_measure_without_calculator,
            viewModel.getScheduleMeasureData()
          );
        }
      },
      render: {
        merchandiseLayout: function renderBuybeltMerchandiseLayout(pip) {
          var buybeltData = {
            fulfillmentLabels: viewModel.getFulfillmentLabels(),
            storeMarkup: view.render.merchandiseStoreLayout(),
            shippingMarkup: view.render.merchandiseShippingLayout(pip),
            messagingMarkup: Mustache.render(view.templates.getMessagingTemplate(), pip),
            subBuybeltMarkup: view.render.subBuybelt()
          };

          if (pip.viewModel.bossSharedSkuEnhancementFeature) {
            buybeltData.features = {
              bossSharedSkuEnhancementFeatureEnabled: true
            };
          }

          return Mustache.render(view.templates.raw.merchandise, buybeltData);
        },
        merchandiseStoreLayout: function renderBuybeltMerchandiseStoreLayout() {
          if (pip.viewModel.bossSharedSkuEnhancementFeature) {
            return Mustache.render(view.templates.getStoreTemplate(), pip);
          }
          if (pip.features.sharedSkuOnlineQuantityEnabled) {
            if (pip.products.primary.data.availabilityType === "Online") {
              return Mustache.render(view.templates.getStoreTemplate(), pip, {
                partial_store_inventory_warning:
                    Mustache.render(view.templates.raw.shipping__online_inventory_warning, pip)
              });
            }
          }
          return Mustache.render(view.templates.getStoreTemplate(), pip, {partial_store_inventory_warning: Mustache.render(view.templates.raw.store_inventory_warning, pip)});
        },
        merchandiseShippingLayout: function renderBuybeltMerchandiseShippingLayout(pip) { 
          return Mustache.render(view.templates.getShippingTemplate(), pip,
            {
              partial_shipping_threshold: Mustache.render(view.templates.raw.shipping__threshold, pip),
              shipping__options_link_bodfs_as_service_level: Mustache.render(view.templates.raw.shipping__options_link_bodfs_as_service_level, pip),
              online_inventory_warning: Mustache.render(view.templates.raw.shipping__online_inventory_warning, pip)
            });
        },
        buybeltLayout: function renderBuybeltLayout() {
          if (pip.installServices.scheduleAMeasure || pip.installServices.scheduleAnAppointment) {
            return Mustache.render(
              view.templates.getInstallServicesTemplate(), pip, {partial_shipping_threshold: Mustache.render(view.templates.raw.shipping__threshold, pip)}
            );
          }
          return view.render.merchandiseLayout(pip);
        },
        subBuybelt: function renderBuybeltSubBuybelt() {
          viewModel.updateSubBuybeltViewModel();
          if (pip.viewModel.buybelt.subBuybelt.full) {
            pip.viewModel.buybelt.subBuybelt.full = Mustache.render(pip.viewModel.buybelt.subBuybelt.full, pip);
          } else {
            $(pip.viewModel.buybelt.subBuybelt.columns).each(function (index, value) {
              pip.viewModel.buybelt.subBuybelt.columns[index] = Mustache.render(value, pip);
            });
          }
          return Mustache.render(view.templates.raw.sub_buybelt, pip);
        },
        uppersubBuybelt: function renderupperBuybeltSubBuybelt() {
          viewModel.updateupperSubBuybeltViewModel();
          if (pip &&
            pip.viewModel &&
            pip.viewModel.buybelt &&
            pip.viewModel.buybelt.uppersubBuybelt &&
            pip.viewModel.buybelt.uppersubBuybelt.full) {
            pip.viewModel.buybelt.uppersubBuybelt.full = Mustache.render(pip.viewModel.buybelt.uppersubBuybelt.full, pip);
          } else {
            $(pip.viewModel.buybelt.uppersubBuybelt.twocolumns).each(function (index, value) {
              pip.viewModel.buybelt.uppersubBuybelt.twocolumns[index] = Mustache.render(value, pip);
            });
          }
          return Mustache.render(view.templates.raw.sub_buybelt, pip);
        }
      },
      updateDOM: {
        subBuybelt: function buybeltSubBuybeltUpdateDOM() {
          $(view.selectors.subBuybelt).html(view.render.subBuybelt());
        },
        uppersubBuybelt: function buybeltupperSubBuybeltUpdateDOM() {
          $(view.selectors.uppersubBuybelt).html(view.render.uppersubBuybelt());
        },
        buybeltStoreBox: function buybeltStoreBoxUpdateDOM() {
          $(view.selectors.storeWrapper).html(view.render.merchandiseStoreLayout());
        },
        buybeltShippingBox: function buybeltShippingBoxUpdateDOM(pip) {
          $(view.selectors.onlineWrapper).html(view.render.merchandiseShippingLayout(pip));
        },
        buybelt: function buybeltUpdateDOM(buybeltMarkup) {
          $(view.selectors.buybeltWrapper).html(buybeltMarkup).velocity('transition.fadeIn');
        },
        buybeltShippingATCLabel: function buybeltShippingATCLabelUpdateDOM(optedIn) {
          $(view.selectors.atcButtonText).text(optedIn ? 'Subscribe' : 'Add to Cart');
        },
        buybeltShippingFreeDeliveryMessage: function buybeltShippingFreeDeliveryMessageUpdateDOM(optedIn) {
          var freeDeliveryMessageWrapper = $(view.selectors.freeDeliveryMessageWrapper);
          $(view.selectors.freeDeliveryMessage).text(optedIn ? 'Free Delivery On Your Schedule' : 'Free Delivery');
          if (optedIn) {
            freeDeliveryMessageWrapper.addClass(view.selectors.freeDeliveryMessageSubscribedClassName);
          } else {
            freeDeliveryMessageWrapper.removeClass(view.selectors.freeDeliveryMessageSubscribedClassName);
          }
        },
        buybeltSubscriptionOptionsMessage: function buybeltSubscriptionOptionsMessageUpdateDOM(optedIn) {
          var subscriptionOptionsMessage = $(view.selectors.subscriptionOptionsMessage);
          subscriptionOptionsMessage.addClass(optedIn
            ? view.selectors.subscriptionOptionsMessageClassName
            : view.selectors.subscriptionOptionsMessageHiddenClassName);
          subscriptionOptionsMessage.removeClass(optedIn
            ? view.selectors.subscriptionOptionsMessageHiddenClassName
            : view.selectors.shippingOptionsTooltipSubscribedClassName);
        },
        buybeltShippingOptionsTooltip: function buybeltShippingOptionsTooltipUpdateDOM(optedIn) {
          var shippingOptionsTooltipLinkContainer = $(view.selectors.shippingOptionsLink);
          shippingOptionsTooltipLinkContainer.addClass(optedIn
            ? view.selectors.shippingOptionsTooltipSubscribedClassName
            : view.selectors.shippingOptionsTooltipUnsubscribedClassName);
          shippingOptionsTooltipLinkContainer.removeClass(optedIn
            ? view.selectors.shippingOptionsTooltipUnsubscribedClassName
            : view.selectors.shippingOptionsTooltipSubscribedClassName);
        },
        buybeltShippingBoxMessage: function buybeltShippingBoxMessageUpdateDOM() {
          var optedIn = (pip.customer.subscriptions && pip.customer.subscriptions.isOptedIn);
          view.updateDOM.buybeltShippingATCLabel(optedIn);
          view.updateDOM.buybeltShippingFreeDeliveryMessage(optedIn);
          view.updateDOM.buybeltSubscriptionOptionsMessage(optedIn);
          view.updateDOM.buybeltShippingOptionsTooltip(optedIn);
        },
        buybeltDeliveryPrice: function buybeltDeliveryPriceUpdateDOM(deliveryPrice, $deliveryPriceMsg) {
          var isValidDeliveryPrice = deliveryPrice && typeof deliveryPrice === 'string' && !isNaN(deliveryPrice.substring(1));
          var MAX_DELIVERY_PRICE_TO_SHOW_MSG = 35;
          var deliveryPriceNumericValue;
          var nonDisplayablePriceMessage;

          if (!isValidDeliveryPrice) {
            return;
          }

          deliveryPriceNumericValue = parseFloat(deliveryPrice.substring(1));

          if (deliveryPriceNumericValue > MAX_DELIVERY_PRICE_TO_SHOW_MSG) {
            nonDisplayablePriceMessage = $(view.selectors.expressDelivery).length ?
              'on the day of your convenience' :
              'at your convenience.';
            $(view.selectors.deliveryPriceMessageSelector).text(nonDisplayablePriceMessage);
          } else {
            $(view.selectors.deliveryPriceMessageSelector).html(function () {
              $deliveryPriceMsg
                .find(view.selectors.deliveryPrice)
                .text(deliveryPrice);

              return $deliveryPriceMsg.html();
            });
          }
        }
      },
      initEventListeners: function buybeltInitEventListeners() {
        var bodfsDetails = pipCommonUtils.getNestedProp(['fulfillment', 'shipping', 'buyOnlineDeliverFromStore'], pip);

        pipEvents.cart.addToCart.off('.pipATC');
        pipEvents.cart.addToCart.on('.pipATC', function () {
          pipCommonUtils.updateHeaderATCcounter();
          view.updateDOM.subBuybelt();
        });

        $(window.document).off('.changePickupStore').on('click.changePickupStore', '.store-inventory-finder-trigger', function (e) {
          e.preventDefault();
          var toolTip = $(e.target).parents('.ToolTip')[0];
          if (toolTip) {
            var toolTipCloseButton = $(toolTip).find(view.selectors.toolTipCloseButton);
            if (toolTipCloseButton) {
              toolTipCloseButton.click();
            }
          }
          var selectAStoreOptions = {
            itemId: pip.products.primary.data.itemId,
            host: pipDomain.getDomain(),
            keyword: pip.customer.localStore.storenumber,
            channel: pip.platformForCart,
            isShipToHomeEligible: !!(pip.fulfillment.shipping && pip.fulfillment.shipping.shipToHome)
          }

          if (pip.features && !!pip.features.addToCartQuantityEnabled) {
            selectAStoreOptions.quantity = pip.customer.quantity || 1;
          }

          if (pip.features && pip.features.buyOneGetOneFreeEnabled) {
            var bogoSelectedItem = pipCommonUtils.deepGet(pip, 'products.primary.data.info.bogoSelectedItem')
            if (bogoSelectedItem) {
              selectAStoreOptions.bogo = bogoSelectedItem;
            }
          }

          thdCartBindings.selectAStore(selectAStoreOptions)
            .on('success', function (resp) {
              /* eslint-disable-next-line no-console */
              pip.debugMode && console.log(resp);
            })
            .on('error', function (resp) {
              /* eslint-disable-next-line no-console */
              pip.debugMode && console.log(resp);
            });
        });

        $(window.document).off('.storeFinderOverlayTrigger').on('click.storeFinderOverlayTrigger', '.store-finder-trigger', function (e) {
          e.preventDefault();
          $(view.selectors.myStore).click();
        });

        $(window.document).off('.primaryATC');
        $(window.document).on('click.primaryATC', '#atc_pickItUp', function () {
          if (pip.features.customProductOfferingEnabled && pip.isB2BCustomer) {
            pipEvents.cart.addToCartAnalytics.trigger();
          }
          if (!pip.viewModel.bossSharedSkuEnhancementFeature && pip.fulfillment && pip.fulfillment.store) {
            if (pip.features.nearbyLimitedStockBOSSEnabled && ((pip.fulfillment.store.buyOnlinePickUpInStore) ||
              (pip.features.multistoreFeatureEnabled && pip.inventory.nearbyStore && pip.inventory.nearbyStore.isInStock))) {
                    pipCart.addBopisItem(pip.products.primary.data.itemId, pip.customer.quantity);
              
            }else if (!pip.features.nearbyLimitedStockBOSSEnabled && ((pip.fulfillment.store.buyOnlinePickUpInStore) ||
              (pip.features.multistoreFeatureEnabled && pip.inventory.nearbyStore))) {
                    pipCart.addBopisItem(pip.products.primary.data.itemId, pip.customer.quantity);
            } else if (pip.fulfillment.store.buyOnlineShipToStore) {
              pipCart.addBossItem(pip.products.primary.data.itemId, pip.customer.quantity);
            }
          } else {
            if ((pip.fulfillment && pip.fulfillment.store && pip.fulfillment.store.buyOnlinePickUpInStore && pip.inventory.store.quantity >= pip.customer.quantity) ||
              (pip.features.multistoreFeatureEnabled && pip.inventory.nearbyStore && pip.inventory.nearbyStore.quantity >= pip.customer.quantity)) {
              pipCart.addBopisItem(pip.products.primary.data.itemId, pip.customer.quantity);
            } else if (pip.fulfillment && pip.fulfillment.store && pip.fulfillment.store.buyOnlineShipToStore) {
              pipCart.addBossItem(pip.products.primary.data.itemId, pip.customer.quantity);
            } else {
              if (pip.features && !!pip.features.addToCartQuantityEnabled) {
                pipCart.addBossItem(pip.products.primary.data.itemId, pip.customer.quantity, "bopisToBoss");
              } else {
                pipCart.addBossItem(pip.products.primary.data.itemId, pip.customer.quantity);
              }
            }
          }
        });

        $(window.document).on('click.primaryATC', '#atc_shipIt', function () {
          if (pip.features.customProductOfferingEnabled && pip.isB2BCustomer) {
            pipEvents.cart.addToCartAnalytics.trigger();
          }
          if (pip.customer.subscriptions && pip.customer.subscriptions.isOptedIn) {
            pipEvents.cart.subscribe.trigger();
          }
          pipCart.addSthItem(pip.products.primary.data.itemId, pip.customer.quantity);
        });

        pipEvents.customer.customerQuantityErrorStateChanged.off('.quantityError');
        pipEvents.customer.customerQuantityErrorStateChanged.on('.quantityError', view.toggleStoreQuantityError);

        if (pip.features.sharedSkuOnlineQuantityEnabled) {
          pipEvents.customer.customerOnlineQuantityErrorStateChanged.off('.quantityError');
          pipEvents.customer.customerOnlineQuantityErrorStateChanged.on('.quantityError', view.toggleOnlineQuantityError);
        }

        pipEvents.customer.customerSubscriptionStateChanged.off('.subscriptionState');
        pipEvents.customer.customerSubscriptionStateChanged.on('.subscriptionState', function () {
          view.updateDOM.buybeltStoreBox();
          view.updateDOM.buybeltShippingBoxMessage();
        });

        $(window.document).off('.shippingLink').on('click.shippingLink', '#shipping_options_link', function (e) {
          e.preventDefault();
          e.stopPropagation();
          pipEvents.shippingOptions.shippingOptionsLinkClicked.trigger({eventName: 'shipping options'});
        });

        pipEvents.shippingOptions.shippingOptionsZipCodeWasChanged.off('.shippingZipChanged');
        pipEvents.shippingOptions.shippingOptionsZipCodeWasChanged.on('.shippingZipChanged', function (evtType, shippingServiceModel) {
          var $deliveryPriceMessage = $(view.selectors.deliveryPriceMessageSelector).clone();

          if (shippingServiceModel.dynamicETA.hasCountdownTimer) {
            pip.fulfillment.shipping.shipToHome.dynamicEta = {};
            pip.fulfillment.shipping.shipToHome.dynamicEta.totalMinutes = shippingServiceModel.dynamicETA.totalMinutes;
          } else {
            delete pip.fulfillment.shipping.shipToHome.dynamicEta;
          }
          pip.fulfillment.shipping.shipToHome.estimatedDeliveryDate = shippingServiceModel.arrivalDateIsSingleDate ? shippingServiceModel.arrivalDate : false;
          pip.fulfillment.shipping.shipToHome.estimatedShippingStartDate = shippingServiceModel.formattedStartDate;
          pip.fulfillment.shipping.shipToHome.estimatedShippingEndDate = shippingServiceModel.formattedEndDate;

          pip.fulfillment.shipping.shipToHome.hasFreeShipping = shippingServiceModel.hasFreeShipping;
          pip.fulfillment.shipping.shipToHome.freeShippingThreshhold = (shippingServiceModel.freeShippingThreshold ? '$' + shippingServiceModel.freeShippingThreshold : false);

          view.updateDOM.buybeltShippingBox(pip);

          if ($deliveryPriceMessage.length) {
            $(view.selectors.deliveryPriceMessageSelector).replaceWith($deliveryPriceMessage);
          }

          if (shippingServiceModel.dynamicETA.hasCountdownTimer) {
            pipDynamicEta.initCountDownTimer();
          } else {
            pipDynamicEta.removeTimers();
          }
        });

        pipEvents.calculator.measureCalculatorStateChanged.off('.measureCalculatorStateChanged');
        pipEvents.calculator.measureCalculatorStateChanged.on('.measureCalculatorStateChanged', function () {
          document.getElementById(view.selectors.nonbuyableSqFtNumberIdName).innerHTML = pip.viewModel.calculator.calculated.squareFootage;
          document.getElementById(view.selectors.nonbuyableServiceEstimate).innerHTML = pip.viewModel.calculator.calculated.totalPrice;
        });

        pipEvents.attachLabor.attachLaborOptInStateChanged.off('.buybeltAttachLaborStateChanged');
        pipEvents.attachLabor.attachLaborOptInStateChanged.on('.buybeltAttachLaborStateChanged', function () {
          view.updateDOM.buybeltStoreBox();
        });

        $(window.document).on('click', view.selectors.showPickUpLink, function (e) {
          e.preventDefault();
          pip.customer.attachLabor.isOptedIn = false;
          pipEvents.attachLabor.attachLaborOptInStateChanged.trigger();
        });

        pipEvents.dualPath.dualPathOptInStateChanged.off('.buybeltDualPath');
        pipEvents.dualPath.dualPathOptInStateChanged.on('.buybeltDualPath', function () {
          view.updateDOM.buybeltStoreBox();
          view.updateDOM.buybeltShippingBox();
        });

        $(window.document).on('click.buybeltDualPath', view.selectors.dualPathOptions, function (e) {
          e.preventDefault();
          pipEvents.dualPath.dualPathBuyBeltLinkClicked.trigger();
        });

        if (bodfsDetails && bodfsDetails.isDeliveryPriceDisplayable) {
          view.initItemQuantityChangeListener();
        }

        $('#howItWorks').tooltip({
          type: 'click',
          position: 'bottom',
          content: function () {
            return Mustache.render(view.templates.raw.buybelt_delivery_tooltip__template, pip.fulfillment.shipping.buyOnlineDeliverFromStore);
        },
          width: 'medium',
          closeButton: true,
          bestPosition: false,
          closeOnClick: true
        });

      },
      initItemQuantityChangeListener: function buybeltInitItemQuantityChangeListener() {
        var debounceAmountInMs = 1000;
        var itemId = pipCommonUtils.getNestedProp(['products', 'primary', 'data', 'itemId'], pip);
        var zipCode = pipCommonUtils.getNestedProp(['customer', 'localStore', 'zipCode'], pip);
        var $deliveryPriceMsg = $(view.selectors.deliveryPriceMessageSelector).clone();
        var debouncedDeliveryPriceCall = debounce(function () {
          var quantity = pipCommonUtils.getNestedProp(['customer', 'quantity'], pip);
            if (itemId && zipCode && quantity) {
              pipCommonUtils.getBodfsDetails(itemId, zipCode, quantity)
                .done(function (response) {
                  view.updateDOM.buybeltDeliveryPrice(response.estDeliveryPrice, $deliveryPriceMsg);
                })
                .fail(function () {
                  if (pip.debugMode) {
                    /* eslint-disable-next-line no-console */
                    console.log('Buybelt delivery price request failed');
                  }
                });
            }
        }, debounceAmountInMs);

        if(!pip.features.bodfsDirectAddToCartOverlayAndPIPSourcingEnabled){
          if ($deliveryPriceMsg.length) {
            pipEvents.pipModel.pipModelQuantityUpdated.off('quantityChange');
            pipEvents.pipModel.pipModelQuantityUpdated.on('quantityChange', debouncedDeliveryPriceCall);
          }
        }
      },
      toggleStoreQuantityError: function buybeltToggleStoreQuantityError(evtType, state) {
        if (pip.viewModel.bossSharedSkuEnhancementFeature) {
          view.toggleFallbackMessages();
          view.showMoreBopisProductsTooltip();
        } else {
          var atcButton = $(view.selectors.addToCartButton);
          atcButton.toggleClass(view.selectors.addToCartButtonErrorStateClassName, state.isErrorState);
        }
      },
      toggleOnlineQuantityError: function buybeltToggleOnlineQuantityError( evtType, state) {
        var shippingAtcButton = $(view.selectors.shippingAddToCartButton);
        shippingAtcButton.toggleClass(view.selectors.addToCartButtonErrorStateClassName, state.isErrorState);
        if (state.isErrorState)
          pipEvents.quantity.quantityErrorAnalytics.trigger();
      },
      toggleFallbackMessages: function buybeltToggleFallbackMessages() {
        var storeFulfillmentTitleSelector = $(view.selectors.fulfillmentTitleFallback);
        var storeHeadingMessageSelector = $(view.selectors.storeMessageHeading);
        var storeOptionsSelector = $(view.selectors.storeMessageOptions);
        var storeCutoffOptionsSelector = $(view.selectors.storeMessageCutoffOptions);

        storeFulfillmentTitleSelector.toggleClass(view.selectors.fulfillmentTitleErrorState);
        storeHeadingMessageSelector.toggleClass(view.selectors.storeMessageHeadingErrorState);
        storeOptionsSelector.toggleClass(view.selectors.storeMessageOptionsErrorState);
        storeCutoffOptionsSelector.toggleClass(view.selectors.storeMessageCutoffOptionsErrorState);
      },
      showMoreBopisProductsTooltip: function buybeltShowMoreBopisProductsTooltip() {
        $(view.selectors.needMoreQuantityTooltip).trigger('click');
        view.disableMoreBopisProductsTooltipAnimation();
      },
      disableMoreBopisProductsTooltipAnimation: function buybeltDisableMoreBopisProductsTooltipAnimation() {
        var disableTransition = 'tooltipDisableTransition';
        var needMoreQuantityHeaderId = '#need-more-quantity-header';
        $('div[id*=tooltip]').has(needMoreQuantityHeaderId).children().addClass(disableTransition);
      }
    };

    var viewModel = {
      updateSubBuybeltViewModel: function () {
        var shouldDisplayExpressDelivery = pipExpressDelivery.shouldDisplayInSubBuyBelt();
        var shouldDisplayPaypal = pipPaypal.isPaypalEligible();
        var bossOffshoreFeatureSwitchEnabled = pip.viewModel.isBossOffshoreEnabled;
        var placeholderHasBeenUsed;
        if (!bossOffshoreFeatureSwitchEnabled) {
          pip.viewModel.buybelt.subBuybelt = {
            shouldDisplay: (pip.fulfillment.fulfillable !== false && pip.customer.isLocalized),
            columns: [
              view.templates.raw.sub_buybelt__paypal,
              view.templates.raw.sub_buybelt__cannot_be_shipped,
              view.templates.raw.sub_buybelt__express_delivery
            ],
            full: (!shouldDisplayPaypal && !shouldDisplayExpressDelivery) ? view.templates.raw.sub_buybelt__cannot_be_shipped : false
          };

          if (!shouldDisplayPaypal) {
            pip.viewModel.buybelt.subBuybelt.columns[0] = view.templates.raw.sub_buybelt__returns;
            placeholderHasBeenUsed = true;
          }

          if (!placeholderHasBeenUsed && !shouldDisplayExpressDelivery) {
            pip.viewModel.buybelt.subBuybelt.columns[2] = view.templates.raw.sub_buybelt__returns;
            placeholderHasBeenUsed = true;
          }

          if (!placeholderHasBeenUsed && !pip.shippingExclusion) {
            pip.viewModel.buybelt.subBuybelt.columns[1] = view.templates.raw.sub_buybelt__returns;
          }
        } else {
          pip.viewModel.buybelt.subBuybelt = {
            shouldDisplay: (pip.fulfillment.fulfillable !== false && pip.customer.isLocalized && shouldDisplayPaypal),
            columns: [
              view.templates.raw.sub_buybelt__paypal,
              view.templates.raw.sub_buybelt__your_localstore_info,
              view.templates.raw.sub_buybelt__returns
            ]
          };
        }
      },
      updateupperSubBuybeltViewModel: function () {
        var hasSeparateBossExclusion = pip.viewModel.hasSeperateBossExclusion;
        pip.viewModel.buybelt.uppersubBuybelt = {
          shouldDisplay: (pip.fulfillment.fulfillable !== false && pip.customer.isLocalized && pip.shippingExclusion),
          twocolumns: [
            view.templates.raw.sub_buybelt__seperate_boss_exclusion,
            view.templates.raw.sub_buybelt__cannot_be_shipped
          ],
          full: (!hasSeparateBossExclusion) ? view.templates.raw.sub_buybelt__cannot_be_shipped : false
        };
      },
      getFulfillmentLabels: function buybeltGetFulfillmentLabels() {
        var storeFulfillmentType = pip.fulfillment && pip.fulfillment.store && pip.fulfillment.store.fulfillmentType ? pip.fulfillment.store.fulfillmentType : null;
        var storeMessage = 'Pick Up In Store';
        var shippingMessage = 'We\'ll Deliver It to You';

        if (storeFulfillmentType === 'BOSS') {
          storeMessage = 'Not in Your Store - We\'ll Ship It There';
        }
        if (storeFulfillmentType === 'BOPIS') {
          if (!pip.fulfillment.store.buyOnlinePickUpInStore.isInventoryRestricted
            && !pip.fulfillment.store.buyOnlinePickUpInStore.isAlphaPromptRestricted
            && !pip.fulfillment.store.buyOnlinePickUpInStore.isStoreAssortmentRestricted
            && !(pip.features.isBopisCutoffEnabled && pipCommonUtils.isAfterBopisCutoff())) {
            storeMessage += ' Today';
          }
        }

        if (pip.features.storeMessagingEnabled) {
          if (pip.fulfillment.isPurchasableInLocalStoreInStock || pip.fulfillment.isZeroStockInLocalStoreActive) {
            storeMessage = 'Pick Up In Store';
          }
          if (pip.fulfillment.isZeroStockInLocalStoreBoss || pip.fulfillment.isPurchasableInLocalStoreBoss) {
            storeMessage = 'Not in Your Store - We\'ll Ship It There';
          }
        }

        if (pip.features.multistoreFeatureEnabled && pip.nearbyStore && !pip.isAnchorStore) {
          if (pip.features.isBopisCutoffEnabled && pipCommonUtils.isAfterBopisCutoff()) {
            storeMessage = 'Pick Up at a Nearby Store';
          }
          else {
            storeMessage = 'Pick Up at a Nearby Store Today';
          }
        }

        if (pip.viewModel.bossSharedSkuEnhancementFeature) {
          return {
            store: {
              bopisMessage: storeMessage,
              bossMessage: 'Not in Your Store - We\'ll Ship It There'
            },
            shipping: shippingMessage
          };
        }

        return {
          store: storeMessage,
          shipping: shippingMessage
        };
      },
      getScheduleMeasureData: function getScheduleMeasureData() {
        var attributeGroups = pipCommonUtils.deepGet(pip.products.primary, 'data.attributeGroups');
        var functionalDetails = (attributeGroups || []).filter(function(group) {
          return group.groupType === 'functional details';
        });

        var entries = pipCommonUtils.deepGet(functionalDetails, '0.entries');
        var inStoreAvailability = (entries || []).filter(function(entry) {
          return entry.name === 'In-Store Availability'
        });

        return {
          sku: pipCommonUtils.deepGet(pip.products.primary, 'data.itemId'),
          skuType: pipCommonUtils.deepGet(inStoreAvailability, '0.value'),
          modelNumber: pipCommonUtils.deepGet(pip.products.primary, 'data.info.modelNumber'),
        }
      },
    };

    function initModules() {
      pipAisleBay.getFormattedAisleBay().done(function (formattedAisleBay) {
        $(view.selectors.aisleBayContainer).html(formattedAisleBay);

        if (pip.viewModel.bossSharedSkuEnhancementFeature) {
          if (formattedAisleBay.length) {
            $(view.selectors.storeMessageOptions).addClass(view.selectors.aisleBayOptionsDisplayClassName);
            $(view.selectors.storeMessageCutoffOptions).addClass(view.selectors.aisleBayOptionsDisplayClassName);
          }
        }

        pipTextAisleBay.init();
      });

      if (pip.viewModel.bossSharedSkuEnhancementFeature) {
        pipNeedMoreBopisProducts.init();
      }

      pipTrackif.init();
      pipPaypal.init();
      pipExpressDelivery.init();
      pipDynamicEta.initCountDownTimer();
      pipCommonExpandable.init();
      pipSubBuyBelt.init();
      pipInstantCheckout.init();
    }

    return {
      init: function init() {
        pipBuyBeltReact.prepLayout();
        pip.viewModel.buybelt.availabilityStatus = {};
        pip.viewModel.bossSharedSkuEnhancementFeature = model.getBossSharedSkuEnhancementFeatureEnabled();
        pip.viewModel.hasSeperateBossExclusion = (pip.shippingExclusion && pip.shippingExclusion.hasSeparateBossSthExclusionLocations);
        pip.viewModel.isBossOffshoreEnabled = (pip.features && pip.features.bossOffshoreEnabled);
        pip.viewModel.doesBossExclusionAppliesInLocalStore = model.doesBossExclusionAppliesInLocalStore();
        var buybeltLayout = (pip.products.primary.data.itemAvailability.discontinuedItem) ? view.templates.raw.messaging__discontinued : view.render.buybeltLayout();
        view.updateDOM.buybelt(buybeltLayout);
        view.updateDOM.subBuybelt();
        view.updateDOM.uppersubBuybelt();

        view.initEventListeners();
        initModules();
        pipBuyBeltReact.init(view);

      },
      templates: view.templates,
      render: view.render,
      updateSubBuyBelt: view.updateDOM.subBuybelt,
      getFulfillmentLabels: viewModel.getFulfillmentLabels,
      updateSubBuybeltViewModel: viewModel.updateSubBuybeltViewModel,
      updateupperSubBuybeltViewModel: viewModel.updateupperSubBuybeltViewModel,
      removeLoadingErrorState: function () {
        $(view.selectors.buybeltErrorState).remove();
      }
    };
  });

}.call(window));